import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.form.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-form-list',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportFormListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public templates: any[] = [];
    public loaded: boolean = false;
    public scopeFilter: string = '';
    public typeFilter: string = '';

    public formTypes = [
        { key: '', label: '전체' },
        { key: 'mentoring_report', label: '멘토링 보고서' },
        { key: 'visit_report', label: '현장방문 보고서' },
        { key: 'ir_report', label: 'IR 보고서' },
        { key: 'plan', label: '기획안' },
        { key: 'promotion', label: '홍보안' },
        { key: 'notice', label: '공지' },
        { key: 'contact_log', label: '연락기록' },
    ];

    // editor state
    public showEditor: boolean = false;
    public editingId: string | null = null;
    public form: any = this._empty();
    public newField: any = { key: '', label: '', type: 'text', required: false, options: '' };

    private _empty() {
        return { scope: 'global', program_id: '', form_type: 'plan', title: '', description: '', fields: [], status: 'active' };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.loaded = true;
        await this.service.render();
    }

    public async load() {
        const res = await wiz.call('search', { scope: this.scopeFilter, form_type: this.typeFilter });
        this.templates = res.data?.rows || [];
        await this.service.render();
    }

    public async seed() {
        const ok = await this.service.alert.show({
            title: '기본 양식 추가',
            message: '기본 양식 7종을 추가합니다. (이미 있으면 스킵)',
            action: '추가',
            cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('seed', {});
        await this.load();
    }

    public openCreate() {
        this.editingId = null;
        this.form = this._empty();
        this.showEditor = true;
    }

    public async openEdit(t: any) {
        this.editingId = t.id;
        const res = await wiz.call('get', { id: t.id });
        const data = res.data?.data || t;
        this.form = { ...data };
        if (typeof this.form.fields === 'string') { try { this.form.fields = JSON.parse(this.form.fields); } catch { this.form.fields = []; } }
        if (!Array.isArray(this.form.fields)) this.form.fields = [];
        this.showEditor = true;
        await this.service.render();
    }

    public closeEditor() { this.showEditor = false; }

    public addField() {
        if (!this.newField.key || !this.newField.label) { this.service.alert.show({ title: '오류', message: 'key/label은 필수' }); return; }
        const f: any = { key: this.newField.key, label: this.newField.label, type: this.newField.type, required: !!this.newField.required };
        if (this.newField.type === 'select' && this.newField.options) {
            f.options = this.newField.options.split(',').map((s: string) => s.trim()).filter(Boolean);
        }
        this.form.fields.push(f);
        this.newField = { key: '', label: '', type: 'text', required: false, options: '' };
    }

    public removeField(i: number) {
        this.form.fields.splice(i, 1);
    }

    public moveField(i: number, dir: number) {
        const j = i + dir;
        if (j < 0 || j >= this.form.fields.length) return;
        const t = this.form.fields[i];
        this.form.fields[i] = this.form.fields[j];
        this.form.fields[j] = t;
    }

    public async submit() {
        if (!this.form.title || !this.form.form_type) { this.service.alert.show({ title: '오류', message: '제목/유형 필수' }); return; }
        const payload: any = { ...this.form };
        const res = await wiz.call('upsert', { id: this.editingId || '', data: JSON.stringify(payload) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showEditor = false;
        await this.load();
    }

    public async remove(t: any) {
        const ok = await this.service.alert.show({
            title: '양식 삭제',
            message: `"${t.title}" 양식을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('remove', { id: t.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' }); return; }
        await this.load();
    }

    public typeLabel(k: string) { const x = this.formTypes.find(t => t.key === k); return x ? x.label : k; }
}

export default PortalLpsysadminSupportFormListComponent;